// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3yRB-","form":"styles_form__1DLhg"};